import type { ComponentEnhancer } from 'recompose';
import LoggerProvider from './Provider';

const withLogger = <P extends {}>({ namespace }: { namespace: string }) => {
  const enhancer = (Component: React.ComponentType<P>) => (props: P) => (
    <LoggerProvider namespace={namespace}>
      <Component {...props} />
    </LoggerProvider>
  );
  return (enhancer as unknown) as ComponentEnhancer<P, P>;
};

export default withLogger;
